import { theme } from '../theme';
export const LOADER_COLOR_VARIABLE = '--wf-loader--color';
export const LOADER_COLOR = `var(${LOADER_COLOR_VARIABLE}, ${theme.text.main})`;
export const ANIMATION_SPEED = '2s';
export const LOGOMARK_ANIMATION_SETTINGS = `${ANIMATION_SPEED} infinite alternate`;
